/**
 * TagList — DS Molecule
 */

import { Badge } from '../../atoms';
import styles from './TagList.module.css';

interface TagListProps {
  tags: string[];
  variant?: 'primary' | 'neutral';
  onAdd?: () => void;
  onRemove?: (tag: string) => void;
  className?: string;
}

export function TagList({ tags, variant = 'primary', onAdd, onRemove, className = '' }: TagListProps) {
  return (
    <div className={`${styles.list} ${className}`}>
      {tags.map(tag => (
        <span key={tag} className={styles.tag}>
          <Badge variant={variant}>{tag}</Badge>
          {onRemove && (
            <button className={styles.remove} onClick={() => onRemove(tag)} aria-label={`Retirer ${tag}`}>
              <i className="bi bi-x" />
            </button>
          )}
        </span>
      ))}
      {onAdd && (
        <button className={styles.addBtn} onClick={onAdd}>
          <i className="bi bi-plus" /> Ajouter
        </button>
      )}
    </div>
  );
}
